<template>
  <ubi-page-container>
    <template v-slot:page-actions>
      <buttons-header-list
          :filter="filter"
          v-on:fetch-models-lots="fetchModelsLots"
          v-on:fetch-models="fetchModels"
          v-on:fetch-models-cmiste="fetchModelsCmiste"
          v-on:reset-to-programs="reset()"
          v-on:gestion-modal-new-lot="gestionModalNewLot"
      />
    </template>
    <div
        v-loading="loadingStatus"
        :element-loading-text="$t('portals.list.chargementDonnees')"
    >
      <!-- Modales -->
      <dialogs-posts-list-immo
          :loadingCMIcreatePost="loadingCMIcreatePost"
          :rulesCMI="rulesCMI"
          :selectModeleCmiste="selectModeleCmiste"
          :selectTerrainCmisteModele="selectTerrainCmisteModele"
          :labelModeleTerrain="labelModeleTerrain"
          :listeTerrains="listeTerrains"
          :listeModeles="listeModeles"
          :listeProgramModeles="listeProgramModeles"
          :currentModelId="currentModelId"
          :currentProgramId="currentProgramId"
          :currentLandId="currentLandId"
          :referenceDuplication="referenceDuplication"
          :modalCmisteModelDisabled="modalCmisteModelDisabled"
          :modalDelete="modalDelete"
          :modalConfirmedDeleteList="modalConfirmedDeleteList"
          :titreModalConfirmedDeleteList="titreModalConfirmedDeleteList"
          :selected="selection"
          :modalConfirmedChangeContactList="modalConfirmedChangeContactList"
          :modalCreationLot="modalCreationLot"
          :modalDuplicate="modalDuplicate"
          v-on:archiver-bv="archiverBienVendu()"
          v-on:close-modal-show-models="modalShowModels = false"
          v-on:fusionner="fusionner($event)"
          v-on:dupliquer="dupliquer($event)"
          v-on:delete-post="supprimer(deleteId)"
          v-on:close-modal-delete="closeModalDelete()"
          v-on:sold-post="vendu(deleteId)"
          v-on:delete-selected="supprimer(selection)"
          v-on:delete-all-selected="supprimerAll(selection)"
          v-on:close-change-contacts="closeChangeContacts()"
          v-on:unselect-call="doSelect(null)"
          v-on:dupliquer-annonce="setReferenceDuplication($event)"
          v-on:close-modal-duplicate="closeModalDuplicate()"
          v-on:stop-popup-bv="closePopupBiensVendus()"
      ></dialogs-posts-list-immo>
      <!-- Fin modales -->

      <!-- Recherche -->
      <el-form @submit.prevent.native="fetchList" label-position="top">
        <search-immo-default
            :filters="filters"
            v-on:find-contacts="handlePostFetch"
            v-on:resetfilter="resetFilter()"
        ></search-immo-default>

        <!--Affichage Vignette-->
        <CardsListImmo
            v-if="affichageReduit === false"
            :affichageReduit="affichageReduit"
            :limits="limits"
            :total="results.total"
            :page="page"
            :limit="limit"
            :sort="sort"
            :sortProperties="sortProperties"
            :results="results"
            :unselect="unselect"
            :annonceFlux="annonceFlux"
            v-on:load-data="fetchList()"
            v-on:switch-published="onSwitchPublished($event)"
            v-on:do-select="doSelect($event)"
            v-on:change-contacts="changeContacts($event)"
            v-on:open-use-model-modal="openUseModelModal($event)"
            v-on:open-duplicate-modal="openDuplicateModal($event)"
            v-on:archiver-bien-vendu-modale="archiverBienVenduModale($event)"
            v-on:modal-delete-list="activationModalConfirmedDeleteList($event)"
            v-on:affichage-reduit="gestionAffichageReduit($event)"
            v-on:exporter="exporter($event)"
            v-on:annonce-parente="setAnnonceParente($event)"
            v-on:diffuse-later="$emit('diffuse-later', $event)"
        />
        <!-- Affichage liste -->
        <div v-else>
          <TableListImmo
              v-if="affichageReduit === true"
              :affichageReduit="affichageReduit"
              :limits="limits"
              :total="results.total"
              :page="page"
              :limit="limit"
              :sort="sort"
              :sortProperties="sortProperties"
              :results="results"
              :annonceFlux="annonceFlux"
              :unselect="unselect"
              v-on:load-data="fetchList"
              v-on:switch-published="onSwitchPublished($event)"
              v-on:do-select="doSelect($event)"
              v-on:change-contacts="changeContacts($event)"
              v-on:open-delete-modal="openDeleteModal($event)"
              v-on:open-use-model-modal="openUseModelModal($event)"
              v-on:open-duplicate-modal="openDuplicateModal($event)"
              v-on:archiver-bien-vendu-modale="archiverBienVenduModale($event)"
              v-on:modal-delete-list="activationModalConfirmedDeleteList($event)"
              v-on:affichage-reduit="gestionAffichageReduit($event)"
              v-on:exporter="exporter($event)"
              v-on:annonce-parente="setAnnonceParente($event)"
              v-on:diffuse-later="$emit('diffuse-later', $event)"
          />
        </div>
      </el-form>
    </div>
  </ubi-page-container>
</template>

<script>
import moment from 'moment'
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
import {
  getPosts
} from '@/services/posts'
import { getUsers, putStopPopupBiensVendus } from '@/services/users'
import ButtonsHeaderList from './Header/ButtonsHeaderList'
import CardsListImmo from '../components/PostsList/CardsListImmo'
import DialogsPostsListImmo from './Dialog/DialogsPostsListImmo'
import TableListImmo from '../components/PostsList/TableListImmo'
import SearchImmoDefault from './Search/SearchImmoDefault'
import { getContactsAnnoncesEnTete } from '@/services/contacts'

export default {
  name: 'PostsListImmo',
  components: {
    ButtonsHeaderList,
    CardsListImmo,
    DialogsPostsListImmo,
    TableListImmo,
    SearchImmoDefault
  },
  data () {
    return {
      affichageReduit: false,
      allPostSelected: [],
      annonceFlux: false,
      annoncesContacts: {},
      bienVenduModaleArchiveNOk: false,
      bienVenduModaleArchiveOk: false,
      bienVenduToArchive: null,
      bienVendus: true,
      changedState: '',
      contacts: [],
      deleteId: null,
      filters: [],
      labelModeleTerrain: '',
      limits: [5, 10, 20, 50],
      listeModeles: null,
      listeProgramModeles: null,
      listeTerrains: null,
      loadingCMIcreatePost: false,
      modalConfirmedChangeContactList: false,
      modalCreateLotFromProgramDisabled: true,
      modalShowModels: false,
      referenceDuplication: null,
      rulesCMI: {
        selectTypeObjetModele: [
          {
            required: true,
            message: this.$t('validator.selectTypeObjetModeleRequired'),
            trigger: 'blur'
          }
        ],
        currentModelId: [
          {
            required: true,
            message: this.$t('validator.currentModelIdRequired'),
            trigger: 'blur'
          }
        ],
        currentProgramId: [
          {
            required: true,
            message: this.$t('validator.currentProgramIdRequired'),
            trigger: 'blur'
          }
        ],
        currentLandId: [
          {
            required: true,
            message: this.$t('validator.currentProgramIdRequired'),
            trigger: 'blur'
          }
        ]
      },
      rulesPromoter: {
        selectTypeObjetModele: [
          {
            required: true,
            message: this.$t('validator.selectTypeObjetModeleRequired'),
            trigger: 'blur'
          }
        ],
        annonceParente: [
          {
            required: true,
            message: this.$t('validator.annonceParenteRequired'),
            trigger: 'blur'
          }
        ]
      },
      saisieEnLigne: false,
      selectModeleCmiste: false,
      selectTerrainCmisteModele: false,
      selected: [],
      selection: [],
      sortProperties: {
        '-DC': this.$t('general.sort.decreaseDate'),
        DC: this.$t('general.sort.increaseDate'),
        R: this.$t('general.sort.reference'),
        T: this.$t('general.sort.title')
      },
      tailleSelectPopup: 24,
      titreModalConfirmedDeleteList: '',
      unselect: false,
      users: []
    }
  },
  computed: {
    ...mapState('postsListImmo', [
      'filter',
      'results',
      'loadingStatus',
      'modalConfirmedDeleteList',
      'modalCreationLot',
      'modalCmisteModelDisabled',
      'modalDuplicate',
      'currentId',
      'currentModelId',
      'currentLandId',
      'currentProgramId',
      'programsModalPromoter'
    ]),
    ...mapState('dialogsPostsListImmo', [
      'selectTypeObjetModele'
    ]),
    ...mapGetters([
      'hasMultiAccounts',
      'isMainAccount',
      'isSubAdmin',
      'isSubUser',
      'getOfferTypes',
      'getPickerOptionsShortcuts',
      'getSitimmoUser',
      'isCmiste'
    ]),
    ...mapGetters('postsListImmo', [
      'getList',
      'annonceParente',
      'fetchModeles',
      'getPage',
      'getLimit',
      'getSort'
    ]),
    ...mapGetters('dialogsPostsListImmo', ['modalDelete']),
    currentId: {
      get () {
        return this.$store.getters['postsListImmo/currentId']
      },
      set (value) {
        this.$store.commit('postsListImmo/SET_CURRENT_ID', value)
      }
    },
    selectTypeObjetModele: {
      get () {
        return this.$store.getters['dialogsPostsListImmo/selectTypeObjetModele']
      },
      set (value) {
        this.$store.commit('dialogsPostsListImmo/SET_SELECT_TYPE_OBJET_MODELE', value)
      }
    },
    modalDelete: {
      get () {
        return this.$store.getters['postsListImmo/modalDelete']
      },
      set (value) {
        this.$store.commit('postsListImmo/SET_MODAL_DELETE', value)
      }
    },
    modalDuplicate: {
      get () {
        return this.$store.getters['postsListImmo/modalDuplicate']
      },
      set (value) {
        this.$store.commit('postsListImmo/SET_MODAL_DUPLICATE', value)
      }
    },
    modalConfirmedDeleteList: {
      get () {
        return this.$store.getters['dialogsPostsListImmo/modalConfirmedDeleteList']
      },
      set (value) {
        this.$store.commit('dialogsPostsListImmo/SET_MODAL_CONFIRMED_DELETE_LIST', value)
      }
    },
    currentModelId: {
      get () {
        return this.$store.getters['postsListImmo/currentModelId']
      },
      set (value) {
        this.$store.commit('postsListImmo/SET_CURRENT_MODEL_ID', value)
      }
    },
    modalCmisteModelDisabled: {
      get () {
        return this.$store.getters['postsListImmo/modalCmisteModelDisabled']
      },
      set (value) {
        this.$store.commit('postsListImmo/SET_MODAL_CMISTE_MODEL_DISABLED', value)
      }
    },
    limit: {
      get () {
        return this.getLimit
      },
      set (value) {
        this.setLimit(value)
        this.setOffset(0)
        this.setPage(1)
        this.fetchList()
      }
    },
    nbStocks () {
      return this.getSitimmoUser.stocks.length
    },
    packExpert () {
      return this.getSitimmoUser.packDiffusion === 'pack_expert'
    },
    page: {
      get () {
        return this.getPage
      },
      set (value) {
        this.setOffset((value - 1) * this.limit)
        this.setPage(value)
        this.fetchList()
      }
    },
    pageTitle () {
      if (this.isPromoteur) {
        if (this.filter.annonceParente) {
          return this.$t('posts.list.pageTitleLots')
        } else {
          return this.$t('posts.list.pageTitlePrograms')
        }
      }
      return this.$t('posts.list.pageTitleAds')
    },
    parentPageTitle () {
      if (this.isPromoteur) {
        if (this.filter.annonceParente) {
          return 'Lots'
        } else {
          return 'Programmes'
        }
      }
      return 'Annonces'
    },
    pickerOptions () {
      return {
        shortcuts: this.getPickerOptionsShortcuts
      }
    },
    possedeContactManager () {
      return this.$store.getters.possedeContactManager
    },
    refreshProgramme () {
      return this.$store.getters['posts/getRefreshProgramme']
    },
    saisit_en_ligne () {
      return (
        this.getSitimmoUser.saisit_annonces_en_ligne === true ||
          this.getSitimmoUser.saisit_en_ligne_et_flux === true
      )
    },
    sort: {
      get () {
        return this.getSort
      },
      async set (value) {
        this.setSort(value)
        this.setOffset(0)
        this.setPage(1)
        await this.fetchList()
      }
    },
    stocks () {
      return this.getSitimmoUser.stocks
    },
    user () {
      return this.$store.getters.getUser
    },
    userJob () {
      return this.getSitimmoUser.metier
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    reduire: function (value) {
      if (!value) return ''
      value = value.toString().substr(0, 47)
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    reduireRef: function (value) {
      if (!value) return ''
      value = value.toString().substr(0, 15)
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  async beforeMount () {
    this.SET_MODAL_SHOW_PROGRAMS_PROMOTER(false)
    this.affichageReduit = this.getAffichageReduitComponent()
    if (this.$route.params.resetParent) {
      this.filter.annonceParente = null
    }

    if (this.fetchModeles) {
      this.SET_ANNONCES_MODELES(true)
      this.SET_PRESET('modeles')
    }

    if (this.$route.name === 'content-library') {
      this.filters = null
      this.filter.page = 1
    } else {
      this.initializePresetFilters()
    }

    if (this.$route.name !== 'content-library') {
      this.$route.meta.title = this.pageTitle
    }

    this.SET_MODAL_SHOW_MODELS_CMISTE(false)
    if (this.$route.matched[1]) {
      this.$route.matched[1].meta.title = this.parentPageTitle
    }

    if (this.$store.getters.saisit_en_ligne === false) {
      this.filters.pop()
    }

    if (this.possedeContactManager) {
      const callContacts = await getContactsAnnoncesEnTete({
        beforeContacts: null,
        afterContacts: null
      })
      if (callContacts.infos && callContacts.infos.infosAnnonces) {
        this.annoncesContacts = callContacts.infos.infosAnnonces
        this.SET_CONTACTS_ANNONCES(this.annoncesContacts)
      }
    }

    // this.fetchList(); //this is done inside searchfilter
    if (this.hasMultiAccounts) {
      this.users = (
        await getUsers({
          active: true,
          pagination: false,
          roles: '!ROLE_CONTACT'
        })
      ).list
    }
    if (this.$route.name === 'content-library') {
      await this.fetchList()
    }

    this.SET_FETCH_MODELES(false)
    // await this.fetchList()
  },
  watch: {
    userFilter: function (user) {
      if (user) {
        const userMatch = this.users.find(x => x.id === this.filter.user)

        if (userMatch.identifierCode && userMatch.identifierValue) {
          this.addFilter({
            dataValues: {
              USER_DATA_CODE: userMatch.identifierCode,
              USER_DATA_VALUE: userMatch.identifierValue
            }
          })
        } else {
          this.addFilter({
            dataValues: { USER_DATA_CODE: null, USER_DATA_VALUE: null }
          })
        }
      } else {
        this.addFilter({
          dataValues: { USER_DATA_CODE: null, USER_DATA_VALUE: null }
        })
      }
    },
    refreshProgramme: function (val) {
      this.SET_ANNONCE_PARENTE(null)
    },
    filter: function (val) {
      if (this.isPromoteur) {
        if (this.filter.annonceParente) {
          this.filters[0].label = this.$t('general.filters.allLots')
        } else {
          this.filters[0].label = this.$t('general.filters.allPrograms')
        }
      }
    }
  },
  methods: {
    ...mapMutations('postsListImmo', [
      'setPage',
      'setLimit',
      'setSort',
      'setSearch',
      'setFilter',
      'addFilter',
      'setOffset',
      'setLimit',
      'SET_LIST',
      'setResults',
      'resetFilter',
      'setObjectType',
      'SET_LOADING_STATUS',
      'SET_LOADING_CMI_CREATE_POST',
      'SET_ANNONCE_PARENTE',
      'SET_CURRENT_LAND_ID',
      'SET_CURRENT_MODEL_ID',
      'SET_CURRENT_ID',
      'SET_CURRENT_PROGRAM_ID',
      'SET_CONTACTS_ANNONCES',
      'SET_ANNONCES_MODELES',
      'SET_PROGRAMS_MODAL_PROMOTER',
      'SET_MODAL_SHOW_MODELS',
      'SET_FETCH_MODELES',
      'SET_PRESET'
    ]),
    ...mapMutations('dialogsPostsListImmo', [
      'SET_MODAL_SHOW_MODELS_CMISTE',
      'SET_MODAL_CONFIRMED_DELETE_LIST',
      'SET_BIEN_VENDU_MODALE_ARCHIVE_OK',
      'SET_POST_TO_DELETE',
      'SET_MODAL_SHOW_PROGRAMS_PROMOTER',
      'SET_MODAL_DUPLICATE',
      'SET_MODAL_USE_MODEL',
      'SET_MODAL_DELETE'
    ]),
    ...mapActions('postsListImmo', ['loadPosts']),
    ...mapActions('dialogsPostsListImmo', ['patchPost']),
    scrollWin () {
      window.scrollTo(500, 0)
    },
    daysRemaining (dateBegin, nbDays) {
      const dateEnd = moment(dateBegin, 'DD/MM/YYYY HH:mm:ss')
        .add(nbDays, 'd')
        .format('DD/MM/YYYY HH:mm:ss')
      const now = moment()
      const remaining = moment(now, 'DD/MM/YYYY HH:mm:ss').diff(
        moment(dateEnd, 'DD/MM/YYYY HH:mm:ss')
      )
      const formattedRemaining = Math.round(
        Math.abs(moment.duration(remaining).asDays())
      )
      return formattedRemaining
    },
    async closePopupBiensVendus () {
      this.SET_LOADING_STATUS(true)
      const result = await putStopPopupBiensVendus(this.user)
      if (result.type === 'error') {
        this.$message({ message: this.$t('error.found'), type: 'error' })
      }
      this.SET_LOADING_STATUS(false)
    },
    async fetchList () {
      this.handleModelFilters()
      this.handleTypeObjetsFilters()
      this.handleBienVendusFilter()

      await this.$store.dispatch('postsListImmo/loadPosts')

      this.handlePostFetch()
      this.scrollWin()
    },

    // Méthodes privées
    handleModelFilters () {
      if (this.isCmiste) {
        this.filter.annoncesModeles = this.$route.name === 'content-library'
      }
    },

    handleTypeObjetsFilters () {
      // Reset du filtre si "all"
      if (this.filter && this.filter.typeObjets !== undefined && this.filter.typeObjets === 'all') {
        delete this.filter.typeObjets
        return
      }

      // Gestion des cas spécifiques
      const hasParentAd = this.filter ? this.filter.annonceParente : false
      let hasTypeObjets = this.filter ? this.filter.typeObjets : null
      if (hasTypeObjets && typeof hasTypeObjets === 'object') {
        hasTypeObjets = (hasTypeObjets.length !== 0)
      }

      if (this.isPromoteur && !hasParentAd && !hasTypeObjets) {
        this.filter.typeObjets = 3000
      } else if (this.isBailleurSocial && !hasParentAd && !hasTypeObjets) {
        delete this.filter.typeObjets
      } else if ((this.isPromoteur || this.isBailleurSocial) && hasParentAd) {
        delete this.filter.typeObjets
      }
    },

    handleBienVendusFilter () {
      if (this.$route.params.getBV) {
        this.filter.annoncesVendues = true
      }
    },

    handlePostFetch () {
      this.updateSourceFlags()
    },

    updateSourceFlags () {
      const hasSaisieImmo = this.results && this.results.list
        ? this.results.list.some(element => element.sourceCode === 'SAISIE_IMMO')
        : false

      const hasFlux = this.results && this.results.list
        ? this.results.list.some(element => element.sourceCode !== 'SAISIE_IMMO')
        : false

      this.saisieEnLigne = hasSaisieImmo
      this.annonceFlux = hasFlux
    },
    async archiverBienVenduModale (state) {
      if (state.published === false) {
        this.bienVenduToArchive = state.id
        // this.bienVenduModaleArchiveOk = true
        this.SET_BIEN_VENDU_MODALE_ARCHIVE_OK = true
      } else {
        this.bienVenduModaleArchiveNOk = true
      }
    },
    async archiverBienVendu () {
      await this.supprimer(this.bienVenduToArchive)
    },
    async exporter (state) {
      let selection = []
      if (state && state.selection) {
        selection = state.selection
      }
      await this.$store.dispatch('postsListImmo/exportPosts', selection)
    },
    formatSelectedIds (selection) {
      if (!selection) return null
      this.selection = selection
      return selection.join(',')
    },
    initializePresetFilters () {
      const baseFilters = [
        { value: 'allAds', label: this.getFilterLabel('allAds', this.isPromoteur) },
        { value: 'enable', label: this.$t('general.filters.activeAds') },
        { value: 'disabled', label: this.$t('general.filters.inactiveOrDraftAds') },
        { value: 'withoutPictures', label: this.$t('general.filters.withoutPictures') }
      ]

      const additionalFilters = {
        promoteur: [
          { value: 'modeles', label: this.$t('general.filters.modelAds') }
        ],
        standard: [
          { value: 'modeles', label: this.$t('general.filters.modelAds') },
          { value: 'deleted', label: this.$t('general.filters.deletedPosts') },
          { value: 'sold', label: this.$t('general.filters.soldPosts') }
        ]
      }

      this.filters = [
        ...baseFilters,
        ...(this.isPromoteur ? additionalFilters.promoteur : this.isCmiste ? [] : additionalFilters.standard)
      ]

      return this.filters
    },
    getFilterLabel (filterType, isPromoteur) {
      if (this.isPromoteur) { return this.$t('general.filters.allPrograms') } else { return this.$t('general.filters.allAds') }
    },
    async fetchTerrains () {
      const terrainsFilters = {
        itemsPerPage: 150
      }
      const result = await getPosts(terrainsFilters)
      if (result.type === 'error') {
        // this.$message({message: this.$t("error.found"), type: 'error'});
        this.SET_LOADING_STATUS(false)
        return false
      }
    },
    async getModels () {
      const result = await getPosts(this.filter)
      if (result.type === 'error') {
        // this.$message({message: this.$t("error.found"), type: 'error'});
        this.SET_LOADING_STATUS(false)
        return false
      }
    },
    async doSelect (type) {
      if (type === '*') {
        this.selected = []
        if (this.results && this.results.list !== undefined) {
          const tmpSelection = this.results.list.map(({ id }) => id)
          this.selected = this.selected.concat(tmpSelection)
        }
      }
      if (type === null) {
        if (this.results && this.results.list !== undefined) {
          this.unselect = true
          this.results.list.map(({ id }) => id)
          this.selected = []
          this.unselect = false
        }
      }
    },
    async setReferenceDuplication (payload) {
      this.referenceDuplication = payload.reference
      let redirect = false
      if (payload.redirect) {
        redirect = true
      }
      const newPayload = {
        id: this.currentId,
        reference: payload.reference,
        redirect: redirect
      }
      await this.dupliquer(newPayload)
    },
    closeModalDuplicate () {
      this.modalDuplicate = false
    },
    closeModalDelete () {
      this.$store.commit('dialogsPostsListImmo/SET_MODAL_DELETE', false)
    },
    closeModalDeleteSelected () {
      this.$store.commit('postsListImmo/setModalConfirmedDeleteList', false)
    },
    async dupliquer (state) {
      console.log('Duplicate')
      const response = await this.$store.dispatch('dialogsPostsListImmo/duplicatePost', {
        id: state.id,
        reference: state.reference
      })
      if (response && response.id) {
        const responsePatch = await this.patchPost({ id: response.id, reference: response.reference, STATUS: 'B' })
        if (responsePatch.ad && responsePatch.ad.id) {
          if (state.redirect) {
            this.$router.push({
              name: 'post-edit',
              params: { id: response.id },
              query: { saisie: 'SAISIE_IMMO' }
            })
          } else {
            await this.fetchList()
          }
        }
      }
    },
    async fusionner (state) {
      const response = await this.$store.dispatch('dialogsPostsListImmo/fusionnerPost', {
        ...state,
        selectTypeObjetModele: this.$store.getters['dialogsPostsListImmo/selectTypeObjetModele']
      })

      if (response && response.type === 'success' && this.isCmiste) {
        if (state.redirect) {
          this.$router.push({
            name: 'post-edit',
            params: { id: response.data.id },
            query: { saisie: 'SAISIE_IMMO' }
          })
        } else {
          await this.fetchList()
        }
      }
    },
    openDuplicateModal (state) {
      this.currentId = state.id
      this.SET_MODAL_DUPLICATE(true)
    },
    eventAnalytics (category) {
      this.$ga.event('annonce', 'clic', category, this.getSitimmoUser.id)
    },
    openUseModelModal (state) {
      this.eventAnalytics('utiliser_modele')
      this.SET_CURRENT_ID(state.id)
      this.SET_MODAL_USE_MODEL(true)
    },
    async supprimer (id) {
      this.unselect = true
      this.SET_LOADING_STATUS(true)

      if (this.$store.getters['dialogsPostsListImmo/postToDelete']) {
        id = this.$store.getters['dialogsPostsListImmo/postToDelete']
      }
      try {
        await this.$store.dispatch('dialogsPostsListImmo/deletePost', id)
      } finally {
        this.SET_LOADING_STATUS(false)
        this.SET_POST_TO_DELETE(null)
        await this.fetchList()
        this.selected = []
        this.unselect = false
      }
    },
    async vendu (id) {
      this.SET_MODAL_DELETE(false)
      this.$router.push({
        name: 'edit-bien-vendu',
        params: {
          id: this.$store.getters['dialogsPostsListImmo/postToDelete']
        }
      })
    },
    async supprimerAll (annonces) {
      this.unselect = true
      this.SET_LOADING_STATUS(true)

      try {
        await this.$store.dispatch('dialogsPostsListImmo/deleteAllPosts', annonces)
      } finally {
        this.SET_LOADING_STATUS(false)
        this.SET_POST_TO_DELETE(null)
        await this.fetchList()
        this.selected = []
        this.unselect = false
      }
    },
    openDeleteModal (state) {
      this.eventAnalytics('supprimer_annonce')
      this.deleteId = state.id
      this.SET_MODAL_DELETE(true)
    },
    async fetchModels () {
      this.eventAnalytics('a_partir_de_modele')
      this.resetFilter()
      this.setFilter({ annoncesModeles: true })
      this.fetchList()
      this.modalShowModels = true
    },
    async fetchModelsCmiste () {
      this.eventAnalytics('a_partir_de_modele')
      this.resetFilter()
      this.fetchTerrains()
      this.getModels()
      this.SET_MODAL_SHOW_MODELS_CMISTE(true)
    },
    async fetchModelsLots () {
      this.eventAnalytics('creer_lot_prom_depuis_modele')
      this.SET_MODAL_SHOW_MODELS(true)
      const annonceParente = this.filter.annonceParente
      this.resetFilter()
      this.setFilter({ annoncesModeles: true })
      this.SET_ANNONCE_PARENTE(annonceParente)
      this.filter.annonceParente = annonceParente
      this.fetchList()
    },
    changeContacts (state) {
      this.selection = state.selection
      this.getSitimmoUser.selectionItem = state.selection
      this.$store.commit('postsVo/setModalConfirmedChangeContactList', true)
    },
    closeChangeContacts () {
      this.$store.commit('postsVo/setModalConfirmedChangeContactList', false)
    },
    reset () {
      this.$store.commit('posts/setAnnonceParente', null)
      this.resetFilter()
      this.fetchList()
    },
    async onSwitchPublished (id, state) {
      this.unselect = true

      const selectedIds = [...this.selected] // Création d'une copie du tableau

      await this.$store.dispatch('postsListImmo/switchPublishedState', {
        id,
        selectedIds,
        isAffichageReduit: this.affichageReduit
      })

      this.unselect = false
    },
    upperCase (string) {
      if (!string) return ''
      return string.charAt(0).toUpperCase() + string.substr(1)
    },
    async setAnnonceParente (idAnnonceParente) {
      this.SET_ANNONCE_PARENTE(idAnnonceParente)
      this.setPage(1)
      await this.fetchList()
      this.updateRouteMeta()
    },

    // Nouvelle méthode extraite
    updateRouteMeta () {
      if (this.$route && this.$route.meta) {
        this.$route.meta.title = this.pageTitle
        if (this.$route.matched && this.$route.matched[1]) {
          this.$route.matched[1].meta.title = this.parentPageTitle
        }
      }
    },
    async handleCommandPromoter (command) {
      if (command.name === 'fetchModels') {
        this.fetchModels()
      }
      if (command.name === 'fetchModelsLots') {
        this.fetchModelsLots()
      }
      if (command.name === 'newProgram') {
        this.$router.push({
          name: 'post-new'
        })
      }
      if (command.name === 'newLot') {
        this.SET_MODAL_SHOW_PROGRAMS_PROMOTER(true)
        const filterPrograms = {
          annonceParente: null,
          page: 1,
          typeObjets: 3000,
          perPage: 250
        }
        const result = await this.$store.dispatch('postsListImmo/loadPosts', filterPrograms)

        this.SET_LOADING_STATUS(false)
        this.SET_PROGRAMS_MODAL_PROMOTER(result.list)
      }
    },
    async gestionModalNewLot () {
      this.SET_LOADING_STATUS(true)
      const filterPrograms = {
        annonceParente: null,
        page: 1,
        typeObjets: 3000,
        perPage: 250
      }
      const result = await getPosts(filterPrograms)
      this.SET_PROGRAMS_MODAL_PROMOTER(result.list)
      this.SET_LOADING_STATUS(false)
      this.SET_MODAL_SHOW_PROGRAMS_PROMOTER(true)
    },
    handleCommand (command) {
      if (command.name === 'delete') {
        this.openDeleteModal(command.id)
      } else if (command.name === 'useModel') {
        this.openUseModelModal(command.id)
      } else if (command.name === 'duplicate') {
        this.openDuplicateModal(command.id)
      } else if (command.name === 'edit') {
        this.$router.push({
          name: 'post-edit',
          params: { id: command.id },
          query: { saisie: command.sourceCode }
        })
      } else if (command.name === 'attendanceReport') {
        this.eventAnalytics('rapport_presence')
        this.$router.push({
          name: 'attendance-report-post',
          params: { post: command.id }
        })
      } else if (command.name === 'diffuseLater') {
        this.eventAnalytics('programmer_diffusion')
        this.$emit('diffuseLater', {
          id: command.id,
          diffuseLaterDate: command.diffuseLaterDate
        })
      } else if (command.name === 'private-note') {
        this.eventAnalytics('acces_note_privee')
        this.$router.push({
          name: 'private-note',
          params: { id: command.id },
          query: { saisie: command.sourceCode }
        })
      }
    },
    gestionAffichageReduit (rep) {
      this.affichageReduit = rep
      this.$store.commit('donnees/SET_AFFICHAGE_REDUIT', this.affichageReduit)
    },
    getAffichageReduitComponent () {
      return this.$store.getters['donnees/getAffichageReduit']
    },
    selectAllChanged (selection) {
      // unselect all case
      if (!selection.length) {
        const self = this
        this.results.list.forEach(function (item) {
          const index = self.selected.indexOf(item.id)
          if (index > -1) {
            this.selected.splice(index, 1)
          }
        }, self)
      } else {
        // select all case
        this.doSelect('*')
      }
    },
    selectedChanged (selection, row) {
      let add = false
      selection.forEach(function (item) {
        if (item.id === row.id) {
          add = true
        }
      })

      const index = this.selected.indexOf(row.id)

      if (add) {
        if (index === -1) {
          this.selected.push(row.id)
        }
      } else {
        if (index > -1) {
          this.selected.splice(index, 1)
        }
      }
    },
    activationModalConfirmedDeleteList (state) {
      this.selection = state.selection
      if (state.quantite == 1) {
        this.titreModalConfirmedDeleteList =
            'Etes-vous sûr de vouloir supprimer votre annonce ?'
      } else {
        this.titreModalConfirmedDeleteList =
            'Etes-vous sûr de vouloir supprimer vos ' +
            state.quantite +
            ' annonces ?'
      }
      this.SET_MODAL_CONFIRMED_DELETE_LIST(true)
    }
  }
}
</script>

<style lang="scss">
@import "@/theme/_bootstrap.scss";
.el-loading-spinner {
  top: 10% !important;
}
.lienContactsListeAnnonces {
  text-decoration: none;
  color: #1a4a56;
}

.lienContactsListeAnnonces.hover {
  text-decoration: underline;
  text-decoration-color: #1a4a56;
  color: #1a4a56;
}

.PostsList {
  &-selection {
    @extend .mb-5;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  /*.no-photo {
    //padding-left: 20%;
    //padding-right: 20%;
    //padding-top: 15%;
    //padding-bottom: 15%;
    //margin-left: 20%;
    //margin-right: 20%;
    //margin-top: 50px;
    //margin-bottom: 50px;
  }*/

  .PostItem {
    &-header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    &-reference {
      @extend .font-secondary;
      text-transform: uppercase;
    }

    &-location,
    &-price,
    &-date {
      font-size: $font-size-lg;
    }

    &-price {
      float: left;
    }

    &-date {
      float: right;
    }

    &-date-program {
      float: right;
      position: relative;
      bottom: 19px;
    }

    &-actions {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    &-contacts {
      @extend .font-secondary;
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    &-contacts-value {
      font-size: $font-size-lg-alt;
      line-height: $font-size-lg-alt;
      font-weight: $font-weight-bold;
    }
    &-contacts-label {
      text-transform: uppercase;
      font-size: $font-size-sm-alt;
    }
  }

  @include media-breakpoint-down(md) {
    &-selection {
      flex-direction: column;
      align-items: flex-start;
    }
    &-export {
      align-self: flex-end;
    }
  }

  @include media-breakpoint-down(sm) {
    &-item {
      margin-bottom: map-get($spacers, 3) !important;
    }

    .PostItem {
      &-actions {
        flex-direction: column;

        .PostItem-buttons {
          margin-bottom: map-get($spacers, 3);
        }
      }

      &-contacts {
        align-self: flex-end;
      }
    }
  }
}
</style>
